import React, { useState, useEffect } from 'react';
import { Container, Row, Col, FormGroup } from 'reactstrap';
import Menu from '../menu/index';
import Image from '../../components/image/index';
import logo from '../../assets/images/Logo.png';
import logoWhite from '../../assets/images/logo-white.png'
import './navbar.scss';


function Navbar() {
    const [activeClass, setactiveClass] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', () => {
                let scoll = null
                if (window.scrollY === 0) {
                    scoll = false
                } else {
                    scoll = true
                }
                setactiveClass(scoll)
            });
        }
    }, [])

    return (
        <div className="App-header">
            <header className={`header-sticky ${activeClass ? 'sticky' : ''}`}>
                <Container>
                    <Row>
                        <Col sm={6} className="left-block">
                            <div className="logo-wrapper">
                                <a href="/">
                                    <Image Path={activeClass ? logo : logoWhite} Class="logo-img" />
                                </a>
                            </div>
                        </Col>
                        <Col sm={6} className="right-block">
                            <div className="search-menu-account-wrapper">
                                <Menu />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </header>
        </div>
    );
}

export default Navbar;
